'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _CamOverlay = require('../CamOverlay');

var _CamOverlay2 = _interopRequireDefault(_CamOverlay);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var CamTimeout = function CamTimeout(_ref) {
  var stillUrl = _ref.stillUrl,
      onClick = _ref.onClick,
      text = _ref.text;
  return _react2.default.createElement(
    'div',
    { className: 'quiver-cam-timeout' },
    _react2.default.createElement(_CamOverlay2.default, { backgroundImage: 'url(' + stillUrl + ')' }),
    _react2.default.createElement(
      'div',
      { className: 'quiver-cam-timeout__message' },
      _react2.default.createElement(
        'div',
        null,
        text.message
      ),
      _react2.default.createElement(
        'button',
        { onClick: onClick },
        text.linkText
      )
    )
  );
};

CamTimeout.propTypes = {
  onClick: _propTypes2.default.func.isRequired,
  stillUrl: _propTypes2.default.string.isRequired,
  text: _propTypes2.default.shape({
    message: _propTypes2.default.string,
    linkText: _propTypes2.default.string
  })
};

CamTimeout.defaultProps = {
  text: {
    message: 'Are you still watching?',
    linkText: 'continue watching'
  }
};

exports.default = CamTimeout;


//////////////////
// WEBPACK FOOTER
// ./~/@surfline/quiver-react/dist/CamTimeout/CamTimeout.js
// module id = 545
// module chunks = 11